import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
interface BonusCardProps {
  title: string;
  value: string;
  description?: string;
  benefits: string[];
  icon: string;
  delay?: number;
  imageUrl?: string;
}
export function BonusCard({
  title,
  value,
  description,
  benefits,
  icon,
  delay = 0,
  imageUrl
}: BonusCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} className="bg-white rounded-xl border border-[#E8CFCF]/30 overflow-hidden flex flex-col h-full hover:border-[#D88C7A]/40 hover:shadow-lg transition-all duration-300" data-id="element-340">
      {/* Image Header */}
      {imageUrl && <div className="relative w-full aspect-[3/4] overflow-hidden bg-[#F5EAEA]" data-id="element-341">
          <img src={imageUrl} alt={title} className="w-full h-full object-cover transition-transform duration-500 hover:scale-105" loading="lazy" decoding="async" data-id="element-342" />
        </div>}

      {/* Content Container */}
      <div className="p-6 flex flex-col flex-grow" data-id="element-343">
        <div className="flex justify-between items-start mb-4" data-id="element-344">
          {!imageUrl && <div className="w-12 h-12 rounded-full bg-[#F5EAEA] flex items-center justify-center text-2xl" data-id="element-345">
              {icon}
            </div>}
          <div className="bg-[#F5EAEA] text-[#D88C7A] text-xs font-bold px-3 py-1 rounded-full border border-[#E8CFCF] ml-auto" data-id="element-346">
            VALOR: {value}
          </div>
        </div>

        <h3 className="text-lg font-bold text-[#3A3A3A] mb-2 leading-tight" data-id="element-347">
          {title}
        </h3>

        {description && <p className="text-[#3A3A3A]/70 text-sm mb-4 leading-relaxed" data-id="element-348">
            {description}
          </p>}

        <ul className="space-y-2 mt-auto pt-4 border-t border-[#E8CFCF]/30" data-id="element-349">
          {benefits.map((benefit, index) => <li key={index} className="flex items-start text-[#3A3A3A]/70 text-sm" data-id="element-350">
              <CheckIcon className="w-4 h-4 text-[#A8B5A2] mr-2 mt-0.5 flex-shrink-0" data-id="element-351" />
              <span data-id="element-352">{benefit}</span>
            </li>)}
        </ul>
      </div>
    </motion.div>;
}